import Vue from 'vue'
import productsQuery from '@queries/products.gql'
import PubSub from '@helper/PubSub'
import mutations from '@root/src/javascripts/store/mutation-types'
import { transformFastQuoteDataForAPI } from '@helper/api'

export default {
  data() {
    return {
      products: [],
      product: {},
      form: {},
      priceCallActive: false,
      valid: true,
    }
  },
  methods: {
    extendAttribute(elementalKey, attributeKey) {
      // extend this.form and make sure that the elemental key is initialized
      if (!this.form.hasOwnProperty(elementalKey)) { // eslint-disable-line no-prototype-builtins
        this.$set(this.form, elementalKey, {})
      }

      this.$set(this.form[elementalKey], attributeKey, null)
    },
    addWatcher(elementalKey, attributeKey) {
      this.$watch(`form.${elementalKey}.${attributeKey}`, async (newValue) => {
        const payload = {
          elemental: elementalKey,
          attribute: attributeKey,
          value: newValue,
        }

        this.$store.commit(mutations.tariffOptions, payload)
        this.valid = await this.$validator.validateAll()
      }, { immediate: true })
    },
    intializeAttribute(elementalKey, attributeKey, value) {
      // override the value with the one in the store
      const tariffOptions = this.$store.state.newContract.tariffOptions || {}
      if (
        tariffOptions.hasOwnProperty(elementalKey) // eslint-disable-line no-prototype-builtins
        && tariffOptions[elementalKey].hasOwnProperty(attributeKey) // eslint-disable-line no-prototype-builtins, max-len
      ) {
        value = tariffOptions[elementalKey][attributeKey] // eslint-disable-line no-param-reassign
      }

      this.form[elementalKey][attributeKey] = value
    },
    makeReactive(elementalKey, attributeKey, value) {
      this.extendAttribute(elementalKey, attributeKey)
      this.intializeAttribute(elementalKey, attributeKey, value)
    },
    setTariffOptions(finished) {
      this.priceCallActive = false

      this.$store.state.newContract.productElementals.forEach((elemental) => {
        let elementalValue = false
        // not optional elementals are always set (initial === true)
        if (elemental.optional === false || elemental.initial === true) {
          elementalValue = true
        }
        this.makeReactive(elemental.key, 'selected', elementalValue)
        this.addWatcher(elemental.key, 'selected')

        elemental.attributes.forEach((attribute) => {
          if (attribute.key === 'payment_frequency') {
            return
          }
          let { value } = attribute.configuration
          if (attribute.type === 'boolean') {
            value = attribute.configuration.checked
          } else if (attribute.type === 'hidden' && elemental.key === 'gross_negligence') {
            value = true
            if (elemental.optional === true && elemental.initial === false) {
              value = false
            }
          }
          this.makeReactive(elemental.key, attribute.key, value)
          this.addWatcher(elemental.key, attribute.key)
        })
      })

      Vue.nextTick(() => {
        this.priceCallActive = true
      })

      if (typeof finished === 'function') {
        finished()
      }
    },
    queryProduct() {
      PubSub.publish('show-loader')

      const variables = transformFastQuoteDataForAPI()

      // IMPORTANT: The products query must not contain the toplevel id field!
      // Because otherwise the Apollo cache will use this ID as a (fragment) cache key and return it
      // in the result of subsequent requests. Even if the request variables are different and
      // therefore a different price should be included in the response.
      return this.$apollo.query({
        query: productsQuery,
        variables,
      })
    },
  },
}
